module.exports = __webpack_public_path__ + "img/EMS_user_manual6.80e0e019.png";